import { Dialog as MUIDialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(MUIDialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(0, 6, 4),
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(4, 6),
    // TODO: no VDS token for this value — needs designer input (2.0rem fontSize)
    fontSize: '2.0rem',
    fontWeight: 500,
    lineHeight: '3.2rem',
    color: theme.palette.text.primary,
    letterSpacing: '0.15px',
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(6),
  },
}));
